/**
 * Copy-to-clipboard handler for the public tracking link.
 * Auto-resets the "copied!" badge after 2 seconds.
 */

import { useState } from 'react'

interface UseCopyTrackingLinkResult {
  linkCopied: boolean
  copy: () => void
}

export function useCopyTrackingLink(
  trackingCode: string | null | undefined
): UseCopyTrackingLinkResult {
  const [linkCopied, setLinkCopied] = useState(false)

  const copy = () => {
    if (!trackingCode) return
    const trackingUrl = `${window.location.origin}/tracking/${trackingCode}`
    navigator.clipboard.writeText(trackingUrl).then(() => {
      setLinkCopied(true)
      setTimeout(() => setLinkCopied(false), 2000)
    })
  }

  return { linkCopied, copy }
}
